import { WorkOSUser } from '@/components/UserProfileSettingDetail'
import { useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'
import { useChangeTeamMemberRole } from './useChangeTeamMemberRole'
import { useGetTeamMembers } from './useGetTeamMembers'
import { useLeaveTeam } from './useLeaveTeam'
import { useRemoveTeamMember } from './useRemoveTeamMember'
import { useSwitchAccount } from './useSwitchAccount'

export const useTeamMembers = () => {
  const [open, onOpenChange] = useState<boolean>(false)
  const [memberIdToRemove, setMemberIdToRemove] = useState<string | null>(null)
  const [user] = useLocalStorage<WorkOSUser | undefined>('_wos_user', undefined)

  const { teamMembers, isLoadingTeamMembers } = useGetTeamMembers(user?.teamId ? true : false)
  const { changeTeamMemberRole, isChangingMemberRole } = useChangeTeamMemberRole()
  const { removeTeamMember, isRemovingTeamMember } = useRemoveTeamMember(() => onOpenChange(false))
  const { switchAccount, isSwitchingAccount } = useSwitchAccount()
  const { leaveTeam, isLeavingTeam } = useLeaveTeam(() => onOpenChange(false))

  const currentRole = teamMembers?.find((m) => m.id === user?.id)?.role ?? ''
  const currentUserCanEditTeamStuff = ['owner', 'creator'].includes(currentRole)
  const currentUserIsOwner = currentRole === 'owner'

  return {
    open,
    onOpenChange,
    memberIdToRemove,
    setMemberIdToRemove,
    teamMembers,
    isLoadingTeamMembers,
    user,
    currentUserCanEditTeamStuff,
    currentUserIsOwner,
    changeTeamMemberRole,
    isChangingMemberRole,
    removeTeamMember,
    isRemovingTeamMember,
    switchAccount,
    isSwitchingAccount,
    leaveTeam,
    isLeavingTeam,
  }
}
